module.exports = __webpack_public_path__ + "static/media/copy.b3b9a3f4.svg";